export default "__VITE_ASSET__aab2cafb__"